import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import axios from 'axios';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import 'leaflet-geosearch/dist/geosearch.css';
import Gps from '../assets/icons/gps.svg'
// Import the custom location icon
import Location from '../assets/icons/location.svg';

// Fix Leaflet's default icon paths
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

// Define a custom marker icon
const customIcon = new L.Icon({
  iconUrl: Location,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

const MapComponent = ({ lat, lng, onSelect }) => {
  const [position, setPosition] = useState([lat || 35.6892, lng || 51.3890]); // Default to Tehran
  const [address, setAddress] = useState('');
  const [zoom, setZoom] = useState(13); // Default zoom level

  // Fetch address using reverse geocoding in Persian
  const fetchAddress = async ({ lat, lng }) => {
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&accept-language=fa`
      );
      if (response.data && response.data.address) {
        const { city, town, village, neighbourhood, road, residential, province } = response.data.address;
        const addressParts = [];
        if (province) addressParts.push(province);
        if (city || town || village) addressParts.push(city || town || village);
        if (neighbourhood) addressParts.push(neighbourhood);
        if (road) addressParts.push(road);
        if (residential) addressParts.push(residential);
        const fullAddress = addressParts.join(', ');
        setAddress(fullAddress);
        onSelect(fullAddress, lat, lng);
      }
    } catch (error) {
      console.error('Error fetching address', error);
    }
  };

  const LocationMarker = () => {
    useMapEvents({
      click(e) {
        const { lat, lng } = e.latlng;
        setPosition([lat, lng]);
        fetchAddress({ lat, lng });
      },
    });

    return <Marker position={position} icon={customIcon}></Marker>;
  };

  const MapWithControl = () => {
    const map = useMap(); // UseMap inside MapContainer context

    useEffect(() => {
      const provider = new OpenStreetMapProvider({
        params: {
          'accept-language': 'fa', // Set language to Persian
        },
      });

      const searchControl = new GeoSearchControl({
        provider,
        style: 'bar',
        autoComplete: true,
        autoCompleteDelay: 250,
        showMarker: false,
      });

      map.addControl(searchControl);

      map.on('geosearch/showlocation', (result) => {
        if (result?.location?.lat !== undefined && result?.location?.lng !== undefined) {
          const { lat, lng } = result.location;
          setPosition([lat, lng]);
          fetchAddress({ lat, lng });
        } else {
          console.error('Invalid location data:', result);
        }
      });

      return () => map.removeControl(searchControl);
    }, [map]);

    return null;
  };

  const RecenterMap = ({ lat, lng }) => {
    const map = useMap(); // UseMap inside MapContainer context

    useEffect(() => {
      if (lat && lng) {
        map.setView([lat, lng], zoom); // Keep the current zoom level when changing position
      }
    }, [lat, lng, map, zoom]);

    return null;
  };

  const handleLocateUser = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setPosition([latitude, longitude]);
          fetchAddress({ lat: latitude, lng: longitude });
        },
        (error) => {
          console.error('Error getting location', error);
          alert('امکان دسترسی به موقعیت مکانی وجود ندارد.');
        }
      );
    } else {
      alert('مرورگر شما از موقعیت‌یابی پشتیبانی نمی‌کند.');
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <MapContainer
        center={position}
        zoom={zoom}  // Keep zoom fixed here
        style={{ height: '400px', width: '100%' }}
        whenCreated={(map) => {
          map.setView(position, zoom);  // Initialize map zoom
        }}
      >
        <TileLayer
          url="https://mt0.google.com/vt/lyrs=m@132&hl=fa&x={x}&y={y}&z={z}"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          minZoom={0}
          maxZoom={22}
        />
        <LocationMarker />
        <MapWithControl />
        <RecenterMap lat={position[0]} lng={position[1]} />
      </MapContainer>
      
      {/* Button inside the map container */}
      <button
        onClick={handleLocateUser}
        style={{
          position: 'absolute',
          bottom: '2em',
          right: '10px',
          padding: '10px',
          background: '#fff',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          zIndex: 1000, // Make sure it's on top of the map
        }}
      >
        <img src={Gps}/>
      </button>

    </div>
  );
};

export default MapComponent;
